var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"calendar-wrapper"}},[_c('div',{staticClass:"breadcrumbs flex-none d-xs-none"},[_c('router-link',{attrs:{"to":{ name: 'root' }}},[_vm._v("Главная")]),_c('i'),_c('span',[_vm._v("Календарь")])],1),(_vm.currentUser)?[_c('CCalendar',{attrs:{"user_id":_vm.currentUser.id,"editable":true}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }